module.exports = __webpack_public_path__ + "static/media/galleryImage07.b67f6f45.jpg";